var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3217 7.44298C13.2883 4.52834 10.6519 3 8.01066 3C4.90864 3 2.23652 5.02086 0.660012 7.45575L0.659273 7.4569C0.554945 7.619 0.49947 7.8077 0.49947 8.00047C0.49947 8.19289 0.554742 8.38125 0.658702 8.54315C2.23385 11.0094 4.88869 13 8.01066 13C11.1659 13 13.7695 11.0135 15.3408 8.55448C15.4476 8.38869 15.5029 8.19503 15.4999 7.99784C15.4969 7.80016 15.4354 7.60781 15.3231 7.44509L15.3217 7.44298ZM14.5001 8.01304L14.4987 8.0152C13.0474 10.287 10.7213 12 8.01066 12C5.33038 12 2.95414 10.2797 1.50112 8.00433L1.50017 8.00284C1.49971 8.00213 1.49947 8.00131 1.49947 8.00047C1.49947 8.00012 1.49951 7.99977 1.4996 7.99943C1.4997 7.999 1.49987 7.99858 1.5001 7.9982C2.95866 5.7461 5.35433 4 8.01066 4C10.2401 4 12.5999 5.29037 14.5001 8.01304Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6ZM11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedEye);
export default __webpack_public_path__ + "static/media/openedEye.a336fb199597209ee40d803311ff73f8.svg";
export { ForwardRef as ReactComponent };